document.addEventListener('DOMContentLoaded', () => {
  const consent = document.getElementById('policyConsent');
  const checkout = document.getElementById('checkoutBtn');
  if (!consent || !checkout) return;

  const toggleCheckout = () => {
    const enable = consent.checked;
    checkout.disabled = !enable;
    checkout.classList.toggle('is-disabled', !enable); // 任意: 見た目用
  };

  toggleCheckout();                 // 初期状態
  consent.addEventListener('change', toggleCheckout);
});

// modal

  /** 開く側 **/
  document.querySelectorAll('.link--modal[data-modal-target]')
    .forEach(link =>
      link.addEventListener('click', e => {
        e.preventDefault();
        const id = link.dataset.modalTarget;
        const modal = document.getElementById(id);
        if (modal){
          modal.classList.add('is-active');
          modal.classList.add('is-visible');
          document.body.classList.add('is-scroll-lock');
        }
      })
    );

  /** 閉じる側（オーバーレイと✕ボタン） **/
  document.querySelectorAll('[data-modal-close]').forEach(el =>
    el.addEventListener('click', () => {
      const modal = el.closest('.modal');
      modal?.classList.remove('is-active');
      modal?.classList.remove('is-visible');
      document.body.classList.remove('is-scroll-lock');
    })
  );

  /** ESCキーで閉じる（任意） **/
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal.is-active')
        .forEach(m => m.classList.remove('is-active'));
      document.querySelectorAll('.modal.is-visible')
        .forEach(m => m.classList.remove('is-visible'));
      document.body.classList.remove('is-scroll-lock');
    }
  });

  /** モーダルの背景をクリックした場合も閉じる **/
  document.querySelectorAll('.modal').forEach(modal => {
    modal.addEventListener('click', e => {
      if (e.target === modal && modal.classList.contains('is-visible')) {
        modal.classList.remove('is-active');
        modal.classList.remove('is-visible');
        document.body.classList.remove('is-scroll-lock');
      }
    });
  });